import {
    Button,
    ExclusiveChoiceDropdown,
    FieldLabel,
    ModalPanel,
    Title
} from "dash-styled"
import React, { FC, FormEvent, useCallback, useState } from "react"
import { useWorkerGroupList } from "../../../../../../Hooks/useWorkerGroupList"
import { APIWorker } from "../../../../../../Models/API/Worker"
import { APIWorkerGroup } from "../../../../../../Models/API/WorkerGroup"
import { getWorkerTypeDisplayText } from "../../../../../../Models/API/WorkerType"
import { getValue } from "../../../../../../Models/Client/FetchState"

interface WorkerAddToModalModalProps {
    orgUsername: string
    workers: APIWorker[]
    isSaving: boolean
    onClose: () => void
    onSubmit: (group: APIWorkerGroup) => void
}

function renderGroup(group: APIWorkerGroup): string {
    return group.name
}

export const WorkerAddToGroupModal: FC<WorkerAddToModalModalProps> = ({
    orgUsername,
    workers,
    isSaving,
    onClose,
    onSubmit
}) => {
    const [groupsFetch, loadMoreGroups] = useWorkerGroupList(orgUsername, {
        sortBy: "name",
        desc: false
    })
    const [group, setGroup] = useState<APIWorkerGroup>()
    const handleSubmit = useCallback(
        (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault()

            if (group === undefined) {
                return
            }

            onSubmit({
                ...group,
                workers: group.workers
                    .concat(workers)
                    .filter((worker, i, arr) => arr.indexOf(worker) === i)
            })
        },
        [group, onSubmit, workers]
    )

    return (
        <ModalPanel onClose={onClose} className="max-w-2xl w-full">
            <Title variant="heading2" weight="semibold" component="h2">
                Add workers to group
            </Title>
            <FieldLabel
                className="mb-2"
                label={workers.length > 1 ? "Workers" : "Worker"}
            ></FieldLabel>
            <ul>
                {workers.map(worker => (
                    <li key={worker.id}>
                        {worker.type === "USER"
                            ? worker.userEmail
                            : getWorkerTypeDisplayText(worker.type)}
                    </li>
                ))}
            </ul>
            <form onSubmit={handleSubmit}>
                <ExclusiveChoiceDropdown
                    className="mt-2"
                    label="Worker group"
                    choices={getValue(groupsFetch)?.items ?? []}
                    value={group}
                    renderChoice={renderGroup}
                    onClick={setGroup}
                    onReachedToEndOfChoices={loadMoreGroups}
                />
                <Button
                    type="submit"
                    className="w-auto mt-8 px-8"
                    disabled={isSaving || group === undefined}
                >
                    {isSaving ? "Adding..." : "Add"}
                </Button>
            </form>
        </ModalPanel>
    )
}
